// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1lKkv","hidden":"Z30hj","container":"_3yHCp","frame":"_1c_0Y"};